import { useCartState } from "@features/cart/useCartState"
import { useFerve } from "./FerveProvider"
import { AlertDialog } from "@components/ui/AlertDialog"
import { Button } from "@components/ui/Button"
import { Countdown } from "@components/ui/Countdown"
import { trackEvent } from "@features/tracking/tracking"

export function CartExpiryWarnings() {
  const state = useCartState()
  const cart = useFerve().cart

  if (state.showingExpiredNotice) {
    return (
      <AlertDialog
        forceOpen
        title="Your cart has expired"
        description={<p>Items in your cart have been removed due to inactivity.</p>}
        canDismiss
        confirmButton="Got it"
        onConfirm={() => {
          cart.state.showingExpiredNotice = false
        }}
      />
    )
  }

  if (state.showingExpiryCountdown && !state.dismissedExpiryCountdown) {
    return (
      <AlertDialog
        forceOpen
        title="Your cart will soon expire"
        description={
          <>
            <p>
              The items in your cart will expire in <Countdown endDate={new Date(state.expiryTime!)} />.
            </p>
            <p>Do you need more time to complete your purchase?</p>
          </>
        }
        canDismiss
        cancelButton={<Button>Dismiss</Button>}
        confirmButton={<Button variant="primary">Yes, I need more time</Button>}
        onCancel={() => {
          cart.state.dismissedExpiryCountdown = true
          trackEvent(
            "Cart Expires Soon Button",
            {
              Action: "Dismissed",
            },
            null,
          )
        }}
        onConfirm={() => {
          cart.bumpCartExpiry()
          trackEvent(
            "Cart Expires Soon Button",
            {
              Action: "Need More Time",
            },
            null,
          )
        }}
      />
    )
  }
}
